import { alpha, display, positions } from "@mui/system";
const styles = (theme) => ({
	pageBox: {
		display: "flex",
		flexDirection: "column",
		gap: 0,
		maxWidth: "100%",
	},
	searchBarContainer: {
		width: "calc(100% + 32px)",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		borderRadius: 0,
		backgroundColor: alpha(theme.palette.background.paper, 0.8),
		backdropFilter: "blur(6px)",
		gap: 2,
		padding: 2,
		position: "relative",
		top: -16,
		left: -16,
	},
	filterGroupItem: {
		width: "310px",
		display: "flex",
		flexDirection: "row",
		alignItems: "center",
		gap: 1,
	},
	newClientButton: { height: "40px" },
	perfilTabs: {
		display: "flex",
		flexDirection: "row",
		gap: 0,
		width: "100%",
		maxWidth: "100vw",
	},
	newClientFloatingMobileButton: {
		position: "fixed",
		bottom: "30px",
		right: "30px",
	},
	filterTypography: {
		textWrap: "nowrap",
	},
	formControl: {
		display: "flex",
		width: "120px",
		minWidth: "120px",
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "primary",
			color: "primary",
		},
		"& .MuiInputLabel-root": {
			color: "primary",
		},
		svg: {
			color: "primary",
		},
		input: {
			color: "primary",
		},
	},
	container: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		position: "relative",
		gap: 2,
	},
	content: { gap: "20px", display: "flex", flexDirection: "column" },
	paper: {
		display: "flex",
		flexDirection: "column",
		padding: "24px 24px 26px",
		bgcolor: theme.palette.mode === "dark" ? "transparent" : "none",
		gap: "16px",
		borderRadius: "10px",
		width: "310px",
		minWidth: "310px",
		position: "sticky",
		top: 130,
		height: "100%",
	},
	avatar: { width: "64px", height: "64px" },

	Icon: {
		fontSize: "26px",
	},

	configBadge: {
		fontSize: "18px",
		position: "absolute",
		bottom: 4,
		right: -8,
	},
	selectedList: {
		color: theme.palette.secondary.main,
		"&.Mui-selected": {
			backgroundColor: "transparent",
		},
	},
	listIconWanguard: { fontSize: "32px", ml: -0.5 },
	infoContratos: {
		marginLeft: "4px",
		width: "15px",
	},
	boxFilters: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
		"@media (max-width: 1350px)": {
			flexDirection: "column",
		},
	},
	searchField: {
		width: 400,
		display: "flex",
		flexGrow: 1,
		fontSize: "0.75rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "8px 8px", // padding interno reduzido
			fontSize: "0.75rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.75rem", // fonte da label
		},
		"@media (max-width: 1350px)": {
			width: "100%",
		},
	},
	filterAutocomplete: {
		fontSize: "0.75rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "6px 8px", // padding interno reduzido
			fontSize: "0.75rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.75rem", // fonte da label
		},
	},
	barraSeletorDireita: {
		display: "flex",
		alignItems: "center",
		gap: 1,
	},
	opcaoCliente: {
		display: "flex",
		alignItems: "center",
		flexWrap: "wrap",
		gap: 1,
	},
});

export default styles;
